import React from 'react';
import styled from 'styled-components';
import { localizable } from 'components/Localization';

const BackButton = styled.a`
  margin-top: 3em;
  display: block;
  text-align: center;
  color: ${(props) => props.theme.palette.themePrimary};
  font-size: 1.5em;
  cursor: pointer;

  i {
    margin-right: 0.2em;
  }
`;

export default localizable('SaleWizardResult')(
  ({ history, store, t, theme }) => (
    <div>
      <h1>{t('Confirmation')}</h1>

      <p>{t('Successful')}</p>

      <BackButton
        theme={theme}
        onClick={() => history.push(`/dashboard/${store.source.saleId}`)}
      >
        <i className="ms-Icon ms-Icon--NavigateBack" aria-hidden="true"></i>
        {t('Back to sale')}
      </BackButton>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/components/Results.jsx